import { cn } from "../lib/utils";

export default function TabNavigation({ tabs, activeTab, onTabChange }) {
  return (
    <div className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 transition-theme">
      <div className="flex overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "flex-1 py-4 px-4 text-center font-medium transition-colors",
              activeTab === tab.id
                ? "tab-active"
                : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
            )}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={cn(
                  "ml-2 text-xs px-2 py-1 rounded-full",
                  activeTab === tab.id
                    ? "bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200"
                    : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300"
                )}
              >
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
